import * as Yup from 'yup';

const schema = Yup.object().shape({
  email: Yup.string().required('email.required').email('email.invalid'),
  password: Yup.string().required('password.required').min(6, 'invalidCredentials').max(40, 'invalidCredentials')
});

export default schema;
